<div class="sync-error">
  <div fxFlex fxFlexFill fxFlexLayout="column" class="container-fluid">
    <div class="state">
      <div class="card">
        <div class="card-body">
          <h2 class="mobile-text-centered" style="margin-top: 8px; margin-bottom: 15px">HCA Error Handling</h2>
          <h5>
            This page displays the accounts that currently have unresolved errors from the B24/7 to PAY1 interface file.
          </h5>
          <div class="grid-container" id="sync-filters">
            <div fxLayout="row" class="fxGap-large mgtp-medium mgbt-medium">
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showPay1Errors" attr.aria-labelledby="showPay1Errors" (valueChange)="updateFilters()"></kendo-switch>
                <label class="switch-label" id="showPay1Errors">Show PAY1 Errors</label>
              </div>
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showB247Holds" attr.aria-labelledby="showB247Holds" (valueChange)="updateFilters()"></kendo-switch>
                <label class="switch-label" id="showB247Holds">Show B24/7 Holds</label>
              </div>
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showAwaiting" attr.aria-labelledby="showAwaiting" (valueChange)="updateFilters()"></kendo-switch>
                <label class="switch-label" id="showAwaiting">Show Awaiting Records</label>
              </div>
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showUnhandledErrors" attr.aria-labelledby="showUnhandledErrors" (valueChange)="updateFilters()"></kendo-switch>
                <label class="switch-label" id="showUnhandledErrors">Show Unhandled Errors</label>
              </div>
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showBlockedByHCA" attr.aria-labelledby="showBlockedByHCA" (valueChange)="updateFilters()"></kendo-switch>
                <label class="switch-label" id="showBlockedByHCA">Show Blocked by HCA</label>
              </div>
              <div fxLayout="row" class="fxGap-small">
                <kendo-switch size="small" [(ngModel)]="filters.showProcessed" attr.aria-labelledby="showProcessed" (valueChange)="updateFilters()"></kendo-switch>
                <label title="Include records accepted by PAY1 or flagged to not send to PAY1." class="switch-label" id="showProcessed">Show Processed</label>
              </div>
            </div>

            <div
                fxLayout="row"
                class="fxGap-medium"
                fxLayoutAlign="space-between"
                style="padding-bottom: 10px; height: 60px;"
              >
              <subscriber-search
                organizationId
                style="flex: 70;"
                [showClearButton]="true"
                textboxPlaceholder="Search by: First Name, Last Name, Last 4 SSN, Full SSN, Tran ID, Member ID"
                (searchSubmitted)="onSearchSubmitted($event)"></subscriber-search>
            </div>
          </div>
          <div class="grid-container">
            <kendo-grid
              #kendoGrid
              [data]="data.l1.clonedGridData"
              class="k-grid-ignore-click"
              [filterable]="'menu'"
              [filter]="data.l1.state.filter"
              [skip]="data.l1.state.skip"
              [sort]="data.l1.state.sort"
              [sortable]="{ mode: 'single', allowUnsort: false }"
              [pageable]="true"
              [pageSize]="20"
              
              (dataStateChange)="dataStateChange($event, data.l1)"
              (detailExpand)="getRowDetails($event)"
              (detailCollapse)="data.l1.selectedItem = null"
              (excelExport)="onL1L2ExcelExport($event)"
            >
              <ng-template *ngIf="data.l1.data?.length" kendoGridToolbarTemplate>
                <button type="button" kendoGridExcelCommand icon="file-excel">Download</button>
              </ng-template>
              <kendo-grid-excel [fetchData]="l1Export.bind(this)" fileName="SyncErrors.xlsx">
                <kendo-excelexport-column
                  *ngFor="let col of data.l2.columns"
                  [field]="col.field"
                  [title]="col.title"
                ></kendo-excelexport-column>
              </kendo-grid-excel>
              <kendo-grid-column
                class="k-grid-ignore-click"
                [style.flex]="col.flex || 1"
                *ngFor="let col of data.l1.columns"
                [field]="col.field"
                [title]="col.title"
                [width]="col.width"
                [format]="col.format"
                [filter]="col.filter ? col.filter : null"
                [headerStyle]="{ 'font-weight': 'bold', 'white-space': 'normal', 'text-align': 'center' }"
              >
                <ng-template kendoGridFilterMenuTemplate
                  let-column="col"
                  let-filter="filter"
                  let-filterService="filterService"
                  *ngIf="col.field.endsWith('Date')"
                  >
                  <date-picker
                    name="dateFilter"
                    [ngModel]="filter.filters[0] ? filter.filters[0].value : null"
                    (ngModelChange)="filterService.filter({ filters: [ { field: col.field, operator: 'eq', value: $event }], logic: 'and' })"
                    [label]="col.title">
                  </date-picker>
                </ng-template>
              </kendo-grid-column>

              <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="grid-container sync-l2-grid">
                  <div fxLayout="row" fxFlex="100">
                    <div fxLayout="row" fxFlex="30" style="font-weight:bold;">
                      <checkbox name="showPendingRecords" [disabled]="!pendingCount" [(ngModel)]="data.l2.filters.showPendingRecords" (change)="updateAccountFilters()" label="Show pending records ({{pendingCount ?? '-'}})"></checkbox>
                    </div>  
                    <div fxLayout="row" fxFlex="30" style="font-weight:bold;">
                      <checkbox name="showProcessedRecords" [disabled]="!processedCount" [(ngModel)]="data.l2.filters.showProcessedRecords" (change)="updateAccountFilters()" label="Show processed records ({{processedCount ?? '-'}})"></checkbox>
                    </div>
                    <div fxLayout="row" fxFlex="30" style="font-weight:bold;">
                      <checkbox name="showDoNotSendRecords" [disabled]="!ignoredCount" [(ngModel)]="data.l2.filters.showDoNotSendRecords" (change)="updateAccountFilters()" label="Show ignored records ({{ignoredCount ?? '-'}})"></checkbox>
                    </div>
                  </div>
                </div>
                <div class="grid-container sync-l2-grid">
                  <kendo-grid
                    [data]="data.l2.clonedGridData"
                    class="k-grid-ignore-click"
                    [filterable]="'menu'"
                    [filter]="data.l2.state.filter"
                    [skip]="data.l2.state.skip"
                    [sortable]="{ mode: 'single', allowUnsort: false }"
                    [sort]="data.l2.state.sort"
                    [pageable]="true"
                    [pageSize]="20"
                    [kendoGridSelectBy]="data.l2.selectBy"
                    [selectedKeys]="data.l2.selectedKeys"
                    [rowClass]="l2RowClass"
                    [selectable]="{ mode: 'multiple' }"
                    
                    (dataStateChange)="dataStateChange($event, data.l2)"
                    (selectionChange)="changeSelection($event, data.l2)"
                    (excelExport)="onL1L2ExcelExport($event)"
                  >
                    <ng-template *ngIf="data.l2.data?.length" kendoGridToolbarTemplate>
                      <button type="button" kendoGridExcelCommand icon="file-excel">Download</button>
                    </ng-template>
                    <kendo-grid-excel [fetchData]="l2Export.bind(this)" fileName="SyncAccountExtract.xlsx"></kendo-grid-excel>
                    <kendo-grid-checkbox-column width="45" *ngIf="isHcaSysAdmin">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" >
                        <input
                          [disabled]="data.l2.selectedItem"
                          class="k-checkbox k-checkbox-md k-rounded-md"
                          [kendoGridSelectionCheckbox]="rowIndex" />
                      </ng-template>
                    </kendo-grid-checkbox-column>
                    <kendo-grid-column
                      class="k-grid-ignore-click"
                      [style.flex]="col.flex || 1"
                      *ngFor="let col of data.l2.columns"
                      [field]="col.field"
                      [title]="col.title"
                      [width]="col.width"
                      [format]="col.format"
                      [filter]="col.filter ? col.filter : null"
                      [headerStyle]="{ 'font-weight': 'bold', 'white-space': 'normal', 'text-align': 'center' }"
                    >
                      <ng-template kendoGridFilterMenuTemplate
                        let-column="col"
                        let-filter="filter"
                        let-filterService="filterService"
                        *ngIf="col.field.endsWith('Date')"
                        >
                        <date-picker
                          name="dateFilter"
                          [ngModel]="filter.filters[0] ? filter.filters[0].value : null"
                          (ngModelChange)="filterService.filter({ filters: [ { field: col.field, operator: 'eq', value: $event }], logic: 'and' })"
                          [label]="col.title">
                        </date-picker>
                      </ng-template>

                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <div *ngIf="col.format.date">
                          {{dataItem[col.field] | date: 'MM/dd/yyyy'}}
                        </div>
                        <div *ngIf="!col.format.date && [ 'errorInfo', 'source' ].indexOf(col.field) === -1">
                          {{dataItem[col.field]}}
                        </div>
                        <ul *ngIf="[ 'errorInfo', 'source' ].indexOf(col.field) > -1">
                          <li *ngFor="let item of dataItem[col.field]">{{item}}</li>
                        </ul>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>

                <div class="grid-container sync-l2-grid" *ngIf="data.l2.firstSelected && !data.l2.selectedItem" fxLayout="row" fxLayoutAlign="start end" fxFlexFill>
                  <div class="form-row" fxLayout="row" fxLayout.lt-md="row" fxLayoutAlign="space-between" fxFlexFill>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15" *ngIf="isHcaSysAdmin">
                      <button title="Resend a record already processed by PAY1 or send a record flagged as processed." [disabled]="!data.l2.all(resendRecordsPredicate)" type="button" class="btn btn-primary" (click)="resendRecords(data.l2.selectedKeys)">Resend records</button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15">
                      <button title="Flag a pending record to never send to PAY1." type="button" [disabled]="!data.l2.all(markAsProcessedPredicate)" class="btn btn-secondary" (click)="markAsProcessed(data.l2.selectedKeys)">Never Send to PAY1</button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15" *ngIf="data.l2.firstSelected.processed">
                      <button title="View audit changes made in PAY1." type="button" [disabled]="!data.l2.firstSelected.processed" class="btn btn-primary" (click)="viewAudits(data.l2.firstSelected.pay1FieldAudits)">View PAY1 Audit</button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15" *ngIf="!data.l2.firstSelected.processed">
                      <button title="Release a B24/7 hold to allow a record to send to PAY1." type="button" [disabled]="!data.l2.all(allowSyncToPay1Predicate)" class="btn btn-primary" (click)="allowSync(data.l2.selectedKeys)">Release B24/7 Hold</button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15">
                      <button title="View information sent to PAY1 and optionally manipulate it, if needed." type="button" [disabled]="data.l2.firstSelected.processed || data.l2.firstSelected.doNotSend || !data.l2.firstSelected.output" class="btn btn-primary" (click)="viewRecordL2(data.l2.selectedKeys)">View/update record data</button>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="15">
                      <button title="View actions performed against this sync record by staff." type="button" [disabled]="data.l2.firstSelected.staffActionCount === 0" class="btn btn-primary" (click)="showStaffActions(data.l2.firstSelected.staffActions)">Staff actions</button>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div>
      <button type="button" class="btn btn-primary" (click)="openSyncLocks()">Manage Sync Locks</button>
    </div>
  </div>

  <kendo-dialog
    title="Detailed sync file record correction"
    *ngIf="data.l2.selectedItem"
    (close)="closeWizardDialogue()"
    [minWidth]="700"
    width="95vw"
    minHeight="350px"
    height="350px"
  >
    <div class="grid-container sync-l4-grid" [class.sub]="l3 === 'sub'" [class.dep]="l3 === 'dep'">
      <kendo-grid
        [data]="data.l3.clonedGridData"
        class="k-grid-ignore-click"
        [sortable]="false"
        [pageable]="false"
      >
        <kendo-grid-column
          class="k-grid-ignore-click"
          [style.flex]="col.flex || 1"
          *ngFor="let col of data.l3.columns"
          [field]="col.field"
          [title]="(col.title === 'signature_date_dt') ? 'Enrollment Signature Date' : col.title"
          [width]="col.width"
          [format]="col.format"
          [filter]="col.filter ? col.filter : null"
          [headerStyle]="{ 'font-weight': 'bold', 'white-space': 'normal', 'text-align': 'center' }"
        >
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div *ngIf="rowIndex === 0 || editableFields.indexOf(col.field) === -1">{{dataItem[col.field]}}</div>
            <div *ngIf="rowIndex > 0 && editableFields.indexOf(col.field) > -1">
              <input
                type="text"
                [name]="col.field"
                [(ngModel)]="dataItem[col.field]"
                [attr.maxlength]="fieldMaxLengths[col.field] || null" />
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>

    <div class="grid-container sync-l4-grid" fxLayout="column" fxLayoutAlign="start end" fxFlexFill>
      <div class="form-row" fxLayout="row" fxLayout.lt-md="row" fxLayoutAlign="space-between" fxFlexFill>
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="20">
          <button type="button" class="btn btn-primary" (click)="closeWizardDialogue()">Cancel</button>
        </div>
        <div fxLayout="column" fxLayoutAlign="end end" fxLayoutGap="gappx" fxFlex="20" *ngIf="isHcaSysAdmin">
          <button type="button" class="btn btn-primary" (click)="saveOutput(data.l2.selectedItem.subscriberMemberId, data.l2.selectedItem.pay1SyncHoldId, data.l3.clonedGridData.data[1])">Save/Exit</button>
        </div>
      </div>
    </div>
  </kendo-dialog>

  <kendo-dialog
    title="Sync Locks"
    *ngIf="showSyncLocks"
    (close)="showSyncLocks = false; addLock = false"
    [minWidth]="700"
    width="95vw"
    minHeight="350px"
    maxHeight="95vw"
  >
    <div *ngIf="!addLock">
      <checkbox label="Show active only" [(ngModel)]="showActiveLocksOnly" (change)="openSyncLocks()"></checkbox>
    </div>
    <div class="grid-container sync-locks" *ngIf="!addLock">
      <kendo-grid
        [data]="data.locks.clonedGridData"
        class="k-grid-ignore-click"
        [filterable]="'menu'"
        [filter]="data.locks.state.filter"
        [skip]="data.locks.state.skip"
        [sortable]="true"
        [pageable]="true"
        [pageSize]="20"
        [kendoGridSelectBy]="data.locks.selectBy"
        [selectedKeys]="data.locks.selectedKeys"
        [selectable]="locksSelectable"
        
        (dataStateChange)="dataStateChange($event, data.locks)"
        (pageChange)="pageChange($event, data.locks)"
        (selectionChange)="changeSelection($event, data.locks)"
      >
        <kendo-grid-checkbox-column width="45" *ngIf="isHcaSysAdmin">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" >
            <input
              class="k-checkbox k-checkbox-md k-rounded-md"
              [kendoGridSelectionCheckbox]="rowIndex" />
          </ng-template>
        </kendo-grid-checkbox-column>
        
        <kendo-grid-column
          class="k-grid-ignore-click"
          [style.flex]="col.flex || 1"
          *ngFor="let col of data.locks.columns"
          [field]="col.field"
          [title]="col.title"
          [width]="col.width"
          [format]="col.format"
          [filter]="col.filter ? col.filter : null"
          [headerStyle]="{ 'font-weight': 'bold', 'white-space': 'normal', 'text-align': 'center' }"
        >
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div *ngIf="col.format.date">
              {{dataItem[col.field] | date: 'MM/dd/yyyy'}}
            </div>
            <div *ngIf="!col.format.date">
              {{dataItem[col.field]}}
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>

    <div style="text-align:center;" *ngIf="!addLock">
      <button class="btn btn-primary" (click)="addLock = true">Add Lock</button>
      <button class="btn btn-primary" [disabled]="!data.locks.selectedKeys.length" (click)="endLocks(data.locks.selectedKeys)">End Lock{{data.locks.selectedKeys.length > 1 ? '(s)' : ''}}</button>
    </div>

    <div *ngIf="addLock">
      <div style="font-weight:bold;margin-bottom:10px;">Add Lock</div>
      <div>
        <div fxFlexFill>
            <div class="form-group required">
                <label for="addLockMemberIdOrSsn">Member ID or SSN</label>
                <input type="text" class="form-control" [(ngModel)]="addLockMemberIdOrSsn" name="addLockMemberIdOrSsn" />
            </div>
        </div>
      </div>
      <div style="text-align:center;">
          <button class="btn btn-primary" (click)="searchLock(addLockMemberIdOrSsn)">Search</button>
      </div>

      <div class="grid-container sync-locks" *ngIf="showSearchLocks">
        <kendo-grid
          [data]="data.searchLocks.clonedGridData"
          class="k-grid-ignore-click"
          [filterable]="'menu'"
          [filter]="data.searchLocks.state.filter"
          [skip]="data.searchLocks.state.skip"
          [sortable]="true"
          [pageable]="true"
          [pageSize]="20"
          [kendoGridSelectBy]="data.searchLocks.selectBy"
          [selectedKeys]="data.searchLocks.selectedKeys"
          
          (dataStateChange)="dataStateChange($event, data.searchLocks)"
          (pageChange)="pageChange($event, data.searchLocks)"
          (selectionChange)="changeSelection($event, data.searchLocks)"
        >
          <kendo-grid-checkbox-column width="45" *ngIf="isHcaSysAdmin">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" >
              <input
                class="k-checkbox k-checkbox-md k-rounded-md"
                [kendoGridSelectionCheckbox]="rowIndex" />
            </ng-template>
          </kendo-grid-checkbox-column>

          <kendo-grid-column
            class="k-grid-ignore-click"
            [style.flex]="col.flex || 1"
            *ngFor="let col of data.searchLocks.columns"
            [field]="col.field"
            [title]="col.title"
            [width]="col.width"
            [format]="col.format"
            [filter]="col.filter ? col.filter : null"
            [headerStyle]="{ 'font-weight': 'bold', 'white-space': 'normal', 'text-align': 'center' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="col.format.date">
                {{dataItem[col.field] | date: 'MM/dd/yyyy'}}
              </div>
              <div *ngIf="!col.format.date">
                {{dataItem[col.field]}}
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <div style="text-align:center;" *ngIf="showSearchLocks">
        <checkbox label="Account-level lock" [(ngModel)]="lockAccountLevel"></checkbox>

        <button class="btn btn-primary" [disabled]="!data.searchLocks.selectedKeys.length" (click)="lockRecords(data.searchLocks.selectedKeys, lockAccountLevel)">Lock Selected Record{{data.searchLocks.selectedKeys.length > 1 ? '(s)' :''}}</button>
      </div>
    </div>
  </kendo-dialog>

  <kendo-dialog
    title="Staff actions performed against this record"
    *ngIf="visibleStaffActions && visibleStaffActions.length > 0"
    (close)="closeStaffActions()"
    [minWidth]="700"
    width="95vw"
    minHeight="350px"
    height="350px"
  >
    <ul *ngFor="let action of visibleStaffActions">
      <li>{{action.action}} performed by {{action.performedBy}} on {{action.timestamp | date: 'MM/dd/yyyy HH:mm'}}</li>
    </ul>

    <div class="grid-container sync-l4-grid" fxLayout="column" fxLayoutAlign="start end" fxFlexFill>
      <div class="form-row" fxLayout="row" fxLayout.lt-md="row" fxLayoutAlign="space-between" fxFlexFill>
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="20">
          <button type="button" class="btn btn-primary" (click)="closeStaffActions()">Close</button>
        </div>
      </div>
    </div>
  </kendo-dialog>

  <kendo-dialog
    title="PAY1 audit information for this record"
    *ngIf="visibleAudits && visibleAudits.length > 0"
    (close)="closeAudits()"
    [minWidth]="700"
    width="95vw"
    minHeight="350px"
    height="350px"
  >
    <ul *ngFor="let audit of visibleAudits">
      <li>{{audit.fieldName}} changed from {{audit.oldValue}} to {{audit.newValue}}</li>
    </ul>

    <div class="grid-container sync-l4-grid" fxLayout="column" fxLayoutAlign="start end" fxFlexFill>
      <div class="form-row" fxLayout="row" fxLayout.lt-md="row" fxLayoutAlign="space-between" fxFlexFill>
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="gappx" fxFlex="20">
          <button type="button" class="btn btn-primary" (click)="closeAudits()">Close</button>
        </div>
      </div>
    </div>
  </kendo-dialog>
</div>